import { z } from "zod";

export interface PromptFilters {
  type?: PromptType[];
  teams?: string[];
  owners?: string[];
  tags?: string[];
  sort?: "created_at" | "last_used_at" | "updated_at";
  search?: string;
  page?: number;
  pageSize?: number;
}

export enum PromptType {
  SAVED = "saved",
  DEFAULT = "default",
}

export const PromptResponseSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string().nullable(),
  prompt_text: z.string(),
  tags: z.array(z.string()),
  teams: z.array(z.coerce.string()).nullable(),
  created_by: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
  last_used_at: z.string().nullable(),
  is_public: z.boolean(),
  attributes: z.record(z.any()).nullable(),
});

export const TagsResponseSchema = z.object({
  tags: z.array(z.string()),
});

export const CreateOrUpdatePromptRequestSchema = z.object({
  title: z.string().optional(),
  description: z.string().optional(),
  prompt_text: z.string().min(1, "Prompt text is required"),
  tags: z.array(z.string()).optional(),
  teams: z.array(z.string()).optional(),
});

// Starter questions response schema - new format
export const StarterQuestionsResponseSchema = z.object({
  hello_message: z.string().nullish(),
  prompts: z.array(PromptResponseSchema),
});

// Enhanced prompt response schema (for improve prompt feature)
export const EnhancedPromptResponseSchema = z.object({
  enhanced_prompt: z.string(),
});

// Type exports
export type PromptResponse = z.infer<typeof PromptResponseSchema>;
export type PromptLibraryTagsResponse = z.infer<typeof TagsResponseSchema>;
export type CreateOrUpdatePromptRequest = z.infer<typeof CreateOrUpdatePromptRequestSchema>;
export type StarterQuestionsResponse = z.infer<typeof StarterQuestionsResponseSchema>;
export type EnhancedPromptResponse = z.infer<typeof EnhancedPromptResponseSchema>;
